module.exports = __webpack_public_path__ + "img/tile-onionskins-desktop_jp.c8c12ca.jpg";